import { useCallback, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { ISelectOption } from "components/Select/Select"
import { IFairValueEvaluationPeriod } from "models/FairValueEvaluation"
import FinanceService from "services/FinanceService"
import toastMessages from "stores/toastMessages"
import dayjs from "utils/dayjs"



export function useFairValueEvaluationPeriods(userProfitCenterIds: string[] | undefined) {

    const { t } = useTranslation()
    const [fairValueEvaluationPeriods, setFairValueEvaluationPeriods] = useState<IFairValueEvaluationPeriod[]>([])
    const [selectedPeriod, setSelectedPeriod] = useState<IFairValueEvaluationPeriod | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchFairValueEvaluationPeriods = useCallback(async ({ initSelectedPeriod }: {
        initSelectedPeriod: boolean
    }) => {
        setIsLoading(true)
        try {
            const _periods = await FinanceService.getFairValueEvaluationPeriods(userProfitCenterIds ?? [])
            setFairValueEvaluationPeriods(_periods)
            if (initSelectedPeriod) {
                setSelectedPeriod(_periods[0] ?? null)
            }
        } catch (e) {
            toastMessages.showSystemError()
        }
        setIsLoading(false)
    }, [userProfitCenterIds])

    const fairValueEvaluationPeriodsOptions = useMemo<ISelectOption<IFairValueEvaluationPeriod>[]>(() =>
        fairValueEvaluationPeriods.map((periodItem, index) => ({
            label: index === 0 ? `${dayjs(periodItem.period).format(t("config.dateMonthYearFormat"))} (${t("fairValueEvaluation.current")})` : dayjs(periodItem.period).format(t("config.dateMonthYearFormat")),
            value: periodItem
        }))
        , [fairValueEvaluationPeriods, t])

    const noPeriods = (fairValueEvaluationPeriods.length <= 1) && !isLoading

    return {
        fairValueEvaluationPeriods,
        fairValueEvaluationPeriodsOptions,
        isLoading,
        fetchFairValueEvaluationPeriods,
        changeSelectedPeriod: setSelectedPeriod,
        selectedPeriod,
        noPeriods
    }

}
